import { Card, CardContent, Grid, Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import React from "react";
import {PortTheme} from "~/ui/theme";
import {Error, CheckFilled} from "~/ui/icons";


export type TerminalReleaseCheckResultProps = {
    name: string
    comment?: string
    success: boolean
}


const useStyles = makeStyles<PortTheme, TerminalReleaseCheckResultProps>(theme => ({
    root: {
        width: "100%",
    },
    icon: {
        color: props => props.success ? "#28BA2C" : "#E53328"
    }
}));


export const TerminalReleaseCheckResult = (props: TerminalReleaseCheckResultProps) => {
    const {name, comment, success} = props;
    const classes = useStyles(props);

    return (
        <Card className={classes.root}>
            <CardContent>
                <Grid container wrap="nowrap" justifyContent="space-between">
                    <Grid item>
                        <Typography variant="cardTitle2" color="primary" display="block" alignSelf="center">
                            {name}
                        </Typography>
                        {comment && (
                            <Typography variant="cardText" color="secondary" marginTop="8px" component="div">
                                {comment}
                            </Typography>
                        )}
                    </Grid>
                    <Grid item marginLeft="8px">
                        {success ? (
                            <CheckFilled className={classes.icon}/>
                        ) : (
                            <Error className={classes.icon}/>
                        )}
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}